import styled, { css } from 'styled-components';

const gridTableCol = css`
  --padding-inline: 24px;

  display: grid;
  grid-template-columns: 60px 1fr 1fr 100px;
  column-gap: 32px;
  padding-inline: var(--padding-inline);
`;

export const Legend = styled.div`
  ${gridTableCol}
  margin-bottom: 24px;

  > *:first-child {
    margin-left: calc(var(--padding-inline) * -1);
  }
`;

export const NewsletterCardContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['small'].includes(prop),
})`
  ${gridTableCol}
  align-items: center;
  padding-block: 20px;
  margin-bottom: 16px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);

  @media ${(props) => props.theme.device.mobileL} {
    display: flex;
    column-gap: 24px;
    padding: 24px;
    margin-bottom: 16px;
  }

  ${({ small }) =>
    small &&
    css`
      display: flex;
      column-gap: 65px;
      padding: 24px 28px;

      @media ${(props) => props.theme.device.mobileL} {
        column-gap: 32px;
      }
    `};
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  align-self: stretch;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  align-self: flex-start;
`;

export const IconBg = styled.div.withConfig({
  shouldForwardProp: (prop) => !['small'].includes(prop),
})`
  width: 60px;
  height: 60px;
  background-color: ${({ theme }) => theme.colors.iconBg};
  border-radius: 50%;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${(props) => props.theme.device.mobileL} {
    width: 80px;
    height: 80px;
  }

  ${({ small }) =>
    small &&
    css`
      width: 130px;
      height: 130px;
    `};
`;

export const HtmlWrapper = styled.div`
  max-height: 120px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
`;
